import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-return-recovery-payment',
    templateUrl: './return-recovery-payment.component.html',
    styleUrls: ['./return-recovery-payment.component.scss'],
    standalone: false
})
export class ReturnRecoveryPayment {
  returnRemark: string;
  constructor(private readonly activeModal: NgbActiveModal) {
  }

  close() {
    this.activeModal.close();
  }

  returnToAccounting() {
    this.activeModal.close(this.returnRemark);
  }
}
